import React from 'react'
import './Banner.css'

export const Banner = () => {
    return (
        <header>
            <div className='center_header_banner'>
                <div className='title_banner'>
                    <h1 className='title'>Hello</h1>
                    <h2 className='subtitle'>I am Developer</h2>
                </div>
            </div>
        </header>
    )
}
